import Emitter from "./Emitter";

export default class GameHistory extends Emitter {
    constructor(gb) {
        super(gb);
    }

    MGS_handler() {
        this.emitParent('{"Name" : "launch_game_history","Origin" : "embeddedgame"}');
        window.dispatchEvent(new CustomEvent(`oryx_game_history_open`));
    }

    POKERSTARS_handler() {
        window.dispatchEvent(new CustomEvent(`oryx_game_history_open`));

        return;
    }

    _default(alreadyHandled) {
        if (alreadyHandled === true) {
            this.emitTop({ wpgaction: "openGameHistory", param: { handled: true } });
            this.emitParent({ wpgaction: "openGameHistory.parent", param: { handled: true } });
            this.emitiOS({ wpgaction: "openGameHistory", param: { handled: true } });
        } else {
            this.emitTop({ wpgaction: "openGameHistory" });
            this.emitParent({ wpgaction: "openGameHistory.parent" });
            this.emitiOS({ wpgaction: "openGameHistory" });

            console.log("Opening Game History via GameBridge");
            window.dispatchEvent(new CustomEvent(`oryx_game_history_open`));
        }
    }
}
